var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contactum-fields" },
    [
      _c(
        "el-select",
        {
          class: _vm.class_names("select"),
          style: { width: "100%" },
          attrs: { disabled: "" }
        },
        _vm._l(_vm.field.options, function(option, key) {
          return _c("el-option", {
            key: key,
            attrs: { label: option.label, value: option.value }
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.field.help
        ? _c("span", {
            staticClass: "help",
            domProps: { innerHTML: _vm._s(_vm.field.help) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }